import React from 'react';
import { motion } from 'framer-motion';
import { DollarSignIcon, ShieldCheckIcon, AwardIcon, StarIcon, ClockIcon } from 'lucide-react';
const values = [{
  title: 'Competitive Rates',
  description: 'Fair, transparent pricing without compromising quality',
  icon: DollarSignIcon
}, {
  title: 'Expertise & Reliability',
  description: 'Over 20 years of trusted commercial experience',
  icon: ShieldCheckIcon
}, {
  title: 'Proven Track Record',
  description: 'Hundreds of successful projects delivered on time',
  icon: AwardIcon
}, {
  title: '5-Star Client Feedback',
  description: 'Consistently rated excellent by our clients',
  icon: StarIcon
}, {
  title: 'Fast Local Response',
  description: 'Rapid response across the Greater Toronto Area',
  icon: ClockIcon
}];
const trustedClients = ['Marriott Hotels', 'Sunnybrook Hospital', 'Nu-Rise Construction Management', 'Twin Pines Developments Inc.', 'Paul Davis Services', 'First General Restoration', 'Integricon Property Restoration and Construction Group Inc.', 'Home Service Club of Canada', 'DS Limited'];
export function WhyChooseUs() {
  return <section id="why-us" className="py-24 bg-white" data-id="element-207">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        {/* Header */}
        <div className="mb-16" data-id="element-209">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex items-center gap-3 mb-4" data-id="element-210">
            <span className="text-primary text-xs font-bold tracking-widest uppercase" data-id="element-211">
              Why Kingsbury
            </span>
            <div className="h-[1px] w-12 bg-border" data-id="element-212" />
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl font-bold text-charcoal" data-id="element-213">
            The Difference Is in the Details
          </motion.h2>
        </div>

        {/* Values Row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8" data-id="element-214">
          {values.map((value, index) => {
          const Icon = value.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="flex flex-col" data-id="element-215">
                <div className="w-14 h-14 rounded-full bg-primary-50 flex items-center justify-center mb-6 border border-primary-100" data-id="element-216">
                  <Icon className="w-6 h-6 text-primary" data-id="element-217" />
                </div>
                <h3 className="text-lg font-bold text-charcoal mb-3" data-id="element-218">
                  {value.title}
                </h3>
                <p className="text-sm text-body leading-relaxed" data-id="element-219">
                  {value.description}
                </p>
              </motion.div>;
        })}
        </div>

        {/* Trusted Clients */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="mt-20 pt-16 border-t border-border" data-id="element-220">
          <div className="text-center mb-10" data-id="element-221">
            <span className="text-primary text-xs font-bold tracking-widest uppercase" data-id="element-222">
              Trusted By
            </span>
            <h3 className="text-2xl md:text-3xl font-bold text-charcoal mt-3" data-id="element-223">
              Our Valued Clients
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-224">
            {trustedClients.map((client, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05 + 0.4
          }} className="bg-warm-grey rounded-lg px-5 py-4 text-center border border-border/50" data-id="element-225">
                <p className="text-sm font-medium text-charcoal" data-id="element-226">{client}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}